// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zFve8GMZPw96pr {
  display: flex;
  position: relative;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
  outline: none;
}
`, ""]);
// Exports
export var popoverBoundary = `zFve8GMZPw96pr`;
export default ___CSS_LOADER_EXPORT___;
